import * as React from "react";
import {formatDateStringToNiceHumanDate} from '../../utils/utils';
import shadowkitLogo from '../../assets/icons/shadowkit.png';

import './Header.scss';

const Header = props => (
	<div className="headerContent">
		<img
			src={shadowkitLogo}
			className={`headerContent__logo`}
			alt={`shadowkit`}
		/>

		<span className={`headerContent__text`}>
			ShadowKit
		</span>

		<div className={`headerContent__metadata`}>
			<span className={`headerContent__tripId`}>
				{props.tripId}
			</span>
			<span className={`headerContent__tripDate`}>
				{ formatDateStringToNiceHumanDate(props.tripDate)}
			</span>
		</div>
	</div>
);

export default Header;